import { render } from "./ContentDetail.vue?vue&type=template&id=44881088&scoped=true&ts=true"
import script from "./ContentDetail.vue?vue&type=script&lang=ts"
export * from "./ContentDetail.vue?vue&type=script&lang=ts"

import "./ContentDetail.vue?vue&type=style&index=0&id=44881088&lang=scss&scoped=true"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44881088"]])

export default __exports__